import React from 'react'
import type { usePainterWorkOrderStyles } from './usePainterWorkOrderStyles'

interface WorkAreaSummaryTotalProps {
  label: string
  value: string | number
  classes: ReturnType<typeof usePainterWorkOrderStyles>
}

export default function WorkAreaSummaryTotal({ label, value, classes }: WorkAreaSummaryTotalProps) {
  return (
    <div className={classes.workAreaTotal}>
      <span className={classes.workAreaCellLabel}>{label}</span>
      <span className={classes.workAreaCellValue}>{value}</span>
    </div>
  )
}
